export const categories = [
  { id: "personal-guard", label: "Personal Guard" },
  { id: "event-security", label: "Event Security" },
];

export const products = {
  "personal-guard": [
    { id: "personal-guard-service", name: "Personal Guard Service", image: "https://cdn.pixabay.com/photo/2017/03/27/12/50/flower-2178507_640.jpg", rent: true, appointment: true, withoutQuantity: false },
  ],
  "event-security": [
    { id: "event-security-service", name: "Event Security Service", image: "https://cdn.pixabay.com/photo/2017/03/27/12/50/flower-2178507_640.jpg", rent: true, appointment: true, withoutQuantity: false },
  ],
};